import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div data-testid="impressum-page" className="min-h-screen bg-[#0C1620]">
      {/* Header */}
      <header className="bg-[#0C1620]/80 backdrop-blur-xl border-b border-[#3A4F60]/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center h-16">
          <Link
            to="/"
            data-testid="back-to-home"
            className="flex items-center gap-2 text-[#8899AA] hover:text-[#C5993A] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-heading text-4xl sm:text-5xl text-white font-light mb-12">
          Impressum
        </h1>

        <div className="space-y-8 text-[#F0F4F8] font-light leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p>VMBS UG</p>
            <p>Ludwigstraße 9</p>
            <p>85298 Scheyern</p>
            <p className="mt-2">Amtsgericht Ingolstadt: HRB 12794</p>
            <p>Geschäftsführer: Hr. Stefan Schäfer</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">Kontakt</h2>
            <p>
              Telefon:{" "}
              <a href="tel:+498441804144" className="text-[#C5993A] hover:underline">
                +49 84 41 80 41 44
              </a>
            </p>
            <p>
              E-Mail:{" "}
              <a href="mailto:info@vmbs.de" className="text-[#C5993A] hover:underline">
                info@vmbs.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">Bildnachweis</h2>
            <p>Headerhintergrund: AdobeStock_287970091-scaled</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              Streitbeilegungsverfahren
            </h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
              diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
              TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
              nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
              Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
              Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte
              wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch
              keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
              jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
              Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
              erkennbar.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
              Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors
              bzw. Erstellers.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-[#3A4F60]/30 py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-[#3A4F60] text-xs">
            &copy; {new Date().getFullYear()} VMBS UG
          </p>
        </div>
      </footer>
    </div>
  );
}
